export default "__VITE_ASSET__eb9cc75a__"